// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","loading_indicator":"Button_loading_indicator__uz7Q9","button-loading-spinner":"Button_button-loading-spinner__qbCsH"};